module.exports = __webpack_public_path__ + "static/media/logo-unesco-nuovo.4ef101b7.png";